@if ((exhibitorLoading$ | async) === false) { @if (contributor$ | async) {
<section>
  <bau365-contact-person-details
    [exhibitor]="exhibitor$ | async"
    [event]="event$ | async"
    [contactPerson]="contactPerson"
    [pageTitle]="pageTitle"
    [pageContext]="'contributor'"
    [socialShareUrl]="socialShareUrl"
    [breadcrumbElements]="breadcrumbElements"
    (trackClickEvent)="trackClick($event)"
    (trackShareDialogOpened)="trackShareDialogOpened()"
    (trackShareButtonClicked)="trackShareButtonClicked($event)"></bau365-contact-person-details>
</section>
} @else { @if ((exhibitorError$ | async) !== '500') {
<bau365-shell-page-not-found></bau365-shell-page-not-found>
} @if ((exhibitorError$ | async) === '500') {
<bau365-shell-page-service-unavailable></bau365-shell-page-service-unavailable>
} } } @else {
<section class="loading-animation">
  <planone-loading-animation></planone-loading-animation>
</section>
}
<ng-template #loading>
  <section class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </section>
</ng-template>
